"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../component");

var _styles = require("../styles");

var _Spin = _interopRequireDefault(require("../Spin"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var loading = _react.default.createElement("span", {
  className: (0, _styles.treeClass)('icon-loading')
}, _react.default.createElement(_Spin.default, {
  name: "ring",
  size: 12
}));

var Content =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Content, _PureComponent);

  function Content(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleNodeClick = _this.handleNodeClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleNodeExpand = _this.handleNodeExpand.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleIndicatorClick = _this.handleIndicatorClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Content.prototype;

  _proto.handleNodeClick = function handleNodeClick() {
    var _this$props = this.props,
        data = _this$props.data,
        id = _this$props.id,
        parentClickExpand = _this$props.parentClickExpand,
        childrenKey = _this$props.childrenKey;
    var children = data[childrenKey];
    var hasChildren = children && children.length > 0;

    if (hasChildren && parentClickExpand) {
      this.handleIndicatorClick();
    } else {
      this.props.onNodeClick(data, id);
    }
  };

  _proto.handleNodeExpand = function handleNodeExpand() {
    var _this$props2 = this.props,
        data = _this$props2.data,
        childrenKey = _this$props2.childrenKey,
        doubleClickExpand = _this$props2.doubleClickExpand;
    if (!doubleClickExpand) return;
    var children = data[childrenKey];
    var hasChildren = children && children.length > 0;
    if (hasChildren) this.handleIndicatorClick();
  };

  _proto.handleIndicatorClick = function handleIndicatorClick() {
    var _this$props3 = this.props,
        id = _this$props3.id,
        data = _this$props3.data,
        onToggle = _this$props3.onToggle,
        loader = _this$props3.loader,
        childrenKey = _this$props3.childrenKey,
        setFetching = _this$props3.setFetching;
    onToggle();
    if (data[childrenKey] !== undefined) return;
    setFetching(true);
    loader(id, data);
  };

  _proto.renderNode = function renderNode() {
    var _this$props4 = this.props,
        id = _this$props4.id,
        active = _this$props4.active,
        data = _this$props4.data,
        renderItem = _this$props4.renderItem,
        expanded = _this$props4.expanded;
    var render = typeof renderItem === 'function' ? renderItem : function (d) {
      return d[renderItem];
    };
    return render(data, expanded, active, id);
  };

  _proto.renderIndicator = function renderIndicator() {
    var _this$props5 = this.props,
        data = _this$props5.data,
        expanded = _this$props5.expanded,
        expandIcons = _this$props5.expandIcons,
        loader = _this$props5.loader,
        childrenKey = _this$props5.childrenKey,
        fetching = _this$props5.fetching,
        iconClass = _this$props5.iconClass;
    var children = data[childrenKey];
    var icon = expandIcons ? expandIcons[expanded + 0] : _react.default.createElement("span", {
      className: (0, _styles.treeClass)('default-icon')
    });

    var indicator = _react.default.createElement("a", {
      onClick: this.handleIndicatorClick,
      className: (0, _classnames.default)((0, _styles.treeClass)("icon-" + (expanded ? 'sub' : 'plus')), iconClass)
    }, typeof icon === 'function' ? icon(data) : icon);

    if (children && children.length > 0) return indicator;
    if (Array.isArray(children) || children === null) return null;
    if (fetching && !children) return loading;
    if (loader && !fetching) return indicator;
    return null;
  };

  _proto.render = function render() {
    var _this$props6 = this.props,
        data = _this$props6.data,
        onToggle = _this$props6.onToggle,
        onChange = _this$props6.onChange,
        expanded = _this$props6.expanded,
        draggable = _this$props6.draggable,
        onDragOver = _this$props6.onDragOver,
        onDrop = _this$props6.onDrop,
        other = _objectWithoutPropertiesLoose(_this$props6, ["data", "onToggle", "onChange", "expanded", "draggable", "onDragOver", "onDrop"]);

    return _react.default.createElement("div", {
      onDragOver: onDragOver
    }, this.renderIndicator(), _react.default.createElement("div", {
      className: (0, _styles.treeClass)('content')
    }, onChange && _react.default.createElement(_Checkbox.default, _extends({}, other, {
      onChange: onChange
    })), _react.default.createElement("div", {
      className: (0, _styles.treeClass)('text'),
      onClick: this.handleNodeClick,
      onDoubleClick: this.handleNodeExpand
    }, this.renderNode())));
  };

  return Content;
}(_component.PureComponent);

Content.propTypes = {
  active: _propTypes.default.bool,
  data: _propTypes.default.object,
  draggable: _propTypes.default.bool,
  expanded: _propTypes.default.bool,
  loader: _propTypes.default.func,
  id: _propTypes.default.any,
  onChange: _propTypes.default.func,
  onToggle: _propTypes.default.func,
  onDragOver: _propTypes.default.func,
  onDrop: _propTypes.default.func,
  onNodeClick: _propTypes.default.func,
  renderItem: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]).isRequired,
  parentClickExpand: _propTypes.default.bool,
  childrenKey: _propTypes.default.string,
  expandIcons: _propTypes.default.array,
  setFetching: _propTypes.default.func,
  fetching: _propTypes.default.bool,
  doubleClickExpand: _propTypes.default.bool,
  iconClass: _propTypes.default.string
};
var _default = Content;
exports.default = _default;